import Endpoints from 'constants/Endpoints';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestGET} from 'libs/RestRequest';

const PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID = "purchasingGroupStageSections";

const __get = async (url, resourcesName, transformer) => {
    try {
        let res = await RestRequestGET(url)
        if (transformer) {
            res = transformer(res);
        }
        reduxStore.dispatch(setResource(resourcesName, res))
        return res;
    } catch (error) {
        console.error(error)
    }
}

const __sectionResponseTranformer = (resp) => {
    return resp.reduce((prev, curr) => {
        prev[curr.section] = curr;
        return prev;
    }, {})
}

const getStage1Sections = async (groupId) => {
    return await __get(Endpoints.PURCHASING_GROUP_SECTIONS_PREPARING(groupId ? groupId : -1), PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID, __sectionResponseTranformer)
}

const getStage2Sections = async (groupId) => {
    return await __get(Endpoints.PURCHASING_GROUP_SECTIONS_COLLECTING_DATA(groupId), PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID, __sectionResponseTranformer)
}

const getSections = async (groupId, sections) => {
    const params = {sections: Array.isArray(sections) ? sections.join(",") : sections}
    const resp = await RestRequestGET(Endpoints.PURCHASING_GROUP_SECTIONS_SECTION(groupId), {params})
    const respTransformed = __sectionResponseTranformer(resp);
    const {resources} = reduxStore.getState();
    const curSections = resources[PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID] || {};
    const newSections = {...curSections, ...respTransformed}
    reduxStore.dispatch(setResource(PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID, newSections));
}

const clearResources = (resourceId) => reduxStore.dispatch(clearResource(resourceId))

export default {
    getStage1Sections,
    getStage2Sections,
    getSections,

    clearResources,
    PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID
}